import { useState } from 'react';
import { useTranslation, Drawer, InputTypes, useMasterData, DropDown } from '@nextgen-web-framework/all';
import { inputErrorMessage, inputErrorStatus } from '../Common/InputErrorComponent/utils';
import { GenderInputPropType, RegistrationValidations } from './types/propTypes';
import styles from './GenderInput.module.scss';

const GenderInput = ({ name, value, updateGenderCallback, disabled }: GenderInputPropType) => {
  const t = useTranslation();
  // masterdata
  const config = useMasterData<RegistrationValidations[]>('RegistrationFieldsMasterData');
  const genderField = config?.find((c: RegistrationValidations) => c.pk === 'gender');
  const genderDropdown = genderField?.option;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [error, setError] = useState('');

  function onDropDownClick() {
    if (disabled) {
      return;
    }
    setIsDrawerOpen(true);
  }

  const handlerDrawer = () => (
    <Drawer
      header={t('profile.ProfileInfo.gender')}
      closeIcon
      onClose={() => {
        if (value.length === 0) {
          setError('profile.validationMsg.gender.required');
        }
        setIsDrawerOpen(false);
      }}
      bottomGap={0}
      useReactPortal={true}
      portalContainerId={'react-portal-drawer'}
    >
      <div className={styles['gender-drawer']} data-testid="gender-drawer">
        <div className={styles['gender-results']}>
          {genderDropdown?.map((gender) => (
            <div
              onClick={() => {
                updateGenderCallback(gender.key);
                setIsDrawerOpen(false);
                setError('');
              }}
              tabIndex={-1}
              aria-hidden="true"
              data-testId="gender"
              className={styles['gender']}
              key={gender.key}
            >
              {t(`profile.ProfileInfo.gender.${gender.key}`)}
            </div>
          ))}
        </div>
      </div>
    </Drawer>
  );

  return (
    <div data-testid="gender-input-container" className={styles['gender-input-container']}>
      {isDrawerOpen && handlerDrawer()}
      <div
        className={styles['gender']}
        data-testid="gender-input"
        onClick={onDropDownClick}
        tabIndex={-1}
        aria-hidden="true"
      >
        <DropDown
          id={name}
          data-testid={name}
          type={InputTypes.TEXT}
          name={name}
          value={value ? t(`profile.ProfileInfo.gender.${value}`) : ''}
          dropdownLabel={t('profile.ProfileInfo.gender')}
          disabled={disabled}
          status={inputErrorStatus(true, error)}
          message={inputErrorMessage(t, true, error)}
          className={styles['dropdown']}
          disabledFilter
          onClick={onDropDownClick}
        />
      </div>
    </div>
  );
};
export default GenderInput;
